module.exports = __webpack_public_path__ + "static/media/SDFSA_2-509w.fa0740bb.webp";